'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveHoldByBuyerId = exports.getActiveHold = exports.isRetailPriceHidden = exports.getNetPrice = exports.getSalePrice = exports.getRetailPrice = exports.getPrices = exports.isArt = exports.isJewelry = exports.isFashion = exports.isFurniture = exports.isSold = exports.isOnHold = exports.isUnavailable = exports.getDealerReference = exports.getUrl = exports.getUnavailableReasonCode = exports.getStatus = exports.getSellerId = exports.getProductName = exports.getPricing = exports.getItemId = exports.getHolds = exports.getGender = exports.getCreator = exports.getCondition = exports.getCategory = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsVerticalHelpers = require('dibs-vertical-helpers');

var _dibsVerticalHelpers2 = _interopRequireDefault(_dibsVerticalHelpers);

var _createSelector = require('./utils/createSelector');

var _createSelector2 = _interopRequireDefault(_createSelector);

var _makeSelectorHelpers = require('./utils/makeSelectorHelpers');

var _price = require('./price');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getCategory = exports.getCategory = function getCategory(item) {
  return (0, _lodash2.default)(item, 'vertical');
};
var getCondition = exports.getCondition = function getCondition(item) {
  return (0, _lodash2.default)(item, 'condition.state');
};
var getCreator = exports.getCreator = function getCreator(item) {
  var creator = (0, _lodash2.default)(item, 'creators[0].creator', {});
  return creator.displayName || creator.name;
};
var getGender = exports.getGender = function getGender(item) {
  return (0, _lodash2.default)(item, 'classification.gender');
};
var getHolds = exports.getHolds = function getHolds(item) {
  return (0, _lodash2.default)(item, 'holds', []);
};
var getItemId = exports.getItemId = function getItemId(item) {
  return (0, _lodash2.default)(item, 'id') || (0, _lodash2.default)(item, 'serviceId');
};
var getPricing = exports.getPricing = function getPricing(item) {
  return (0, _lodash2.default)(item, 'pricing', {});
};
var getProductName = exports.getProductName = function getProductName(item) {
  return (0, _lodash2.default)(item, 'title');
};
var getSellerId = exports.getSellerId = function getSellerId(item) {
  return (0, _lodash2.default)(item, 'seller.id');
};
var getStatus = exports.getStatus = function getStatus(item) {
  return (0, _lodash2.default)(item, 'status');
};
var getUnavailableReasonCode = exports.getUnavailableReasonCode = function getUnavailableReasonCode(item) {
  return (0, _lodash2.default)(item, 'unavailableReasonCode');
};
var getUrl = exports.getUrl = function getUrl(item) {
  return (0, _lodash2.default)(item, 'pdpUrls[0]') || (0, _lodash2.default)(item, 'pdpURL') || '';
};
var getDealerReference = exports.getDealerReference = function getDealerReference(item) {
  return (0, _lodash2.default)(item, 'dealerReference') || '';
};

// Selectors
// ------------------------------------------

/**
 * @param {string} status to compare to on the passed-in item
 * @returns {function} selector that checks the status with whats on the
 *                      passed-in item
 */
var itemStatusCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getStatus);
var isUnavailable = exports.isUnavailable = itemStatusCheckSelector('UNAVAILABLE');

/**
 * @param {...string} all reason codes to compare against the unavailable reason
 *                      code actually on the item
 * @returns {function} selector that checks the reason code on the item against the
 *                      given reason codes
 */
var itemUnavailabilityCheckSelector = function itemUnavailabilityCheckSelector() {
  for (var _len = arguments.length, reasonCodes = Array(_len), _key = 0; _key < _len; _key++) {
    reasonCodes[_key] = arguments[_key];
  }

  return (0, _createSelector2.default)(isUnavailable, getUnavailableReasonCode, function (itemIsUnavailable, unavailableReasonCode) {
    return itemIsUnavailable && reasonCodes.indexOf(unavailableReasonCode) > -1;
  });
};
var isOnHold = exports.isOnHold = itemUnavailabilityCheckSelector('ON_HOLD', 'ON_HOLD_CUSTOM');
var isSold = exports.isSold = itemUnavailabilityCheckSelector('SOLD', 'SOLD_ON_PLATFORM');

/**
 * @param {string} category to compare to on the passed-in item
 * @returns {function} selector that checks the vertical of the item
 */
var itemCategoryCheckSelector = (0, _makeSelectorHelpers.makeEqualityCheckSelector)(getCategory);
var isFurniture = exports.isFurniture = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FURNITURE);
var isFashion = exports.isFashion = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_FASHION);
var isJewelry = exports.isJewelry = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_JEWELRY);
var isArt = exports.isArt = itemCategoryCheckSelector(_dibsVerticalHelpers2.default.VERTICAL_ART);

/**
 * @param {object} item
 * @returns {array} prices (i.e. retail, sale, etc) for the item
 */
var getPrices = exports.getPrices = (0, _createSelector2.default)(getPricing, function (pricing) {
  return pricing.prices || [];
});

/**
 * @param {string} price type to get from pricing
 * @returns {function} selector that gets the passed in price type from
 *                      pricing data
 */
var pricingPriceTypeSelector = function pricingPriceTypeSelector(typeToCheck) {
  return (0, _createSelector2.default)(getPrices, function (prices) {
    return prices.find(function (_ref) {
      var type = _ref.type,
          status = _ref.status;
      return type === typeToCheck && status === 'ACTIVE';
    });
  });
};
var getRetailPrice = exports.getRetailPrice = pricingPriceTypeSelector('RETAIL');
var getSalePrice = exports.getSalePrice = pricingPriceTypeSelector('WEEKLY_SALE');
var getNetPrice = exports.getNetPrice = pricingPriceTypeSelector('NET');

/**
 * @param {object} item
 * @returns {boolean} true if retail price is hidden
 */
var isRetailPriceHidden = exports.isRetailPriceHidden = (0, _createSelector2.default)(getRetailPrice, _price.isPriceHidden);

/**
 * @param {object} item
 * @returns {?object} the active hold if there is one, undefined otherwise
 */
var getActiveHold = exports.getActiveHold = (0, _createSelector2.default)(getHolds, function (holds) {
  return holds.find(function (hold) {
    return hold.status === 'ACTIVE';
  });
});

/**
 * @param {object} item
 * @returns {function} function that if given a buyer id will return true/false if the buyer
 *                      owns the active hold
 */
var isActiveHoldByBuyerId = exports.isActiveHoldByBuyerId = (0, _createSelector2.default)(getActiveHold, function (hold) {
  return function (buyerId) {
    if (!buyerId) {
      return false;
    }
    return (0, _lodash2.default)(hold, 'buyer.id') === buyerId || (0, _lodash2.default)(hold, 'buyer.serviceId') === buyerId;
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/dibs-selectors/dist/item.js
// module id = 818
// module chunks = 1 4 6 10 14 17